/**
 * BSW Requirement Sync API functions.
 * Communicates with bsp_back /api/v1/bsw-req/ endpoints.
 */

import apiClient from './client';

export interface BswProject {
  id: number;
  project: string;
  os: string;
  platform: string;
  adcuModel: string;
  mcuModel: string | null;
  isMainline: boolean;
  mountain: string | null;
}

export interface BswRequirement {
  id: number;
  reqId: string;
  owner: string;
  lastChangeDatetime: string | null;
  description: string;
  version: number;
  reqSource: string | null;
  planStage: string;
  deliverables: string | null;
  validationMethod: string;
  validationCriteria: string | null;
  catagory: string;
  catagory2?: string | null;
  reqStatus: string | null;
  attachment: string | null;
  tag: string[] | null;
  hardware: string | null;
  priority: string | null;
}

export interface CompareResult {
  id: number | null;
  project: string;
  subcatagory: string;
  data: BswRequirement[];
}

export interface SyncCompareResponse {
  code: number;
  message: string;
  data: [CompareResult, CompareResult];
}

export interface SyncExecutePayload {
  type: 'add' | 'delete';
  project: string;
  subcatagory: string;
  id: number[];
}

export interface OperationLog {
  id: number;
  project_id: number;
  target_type: string;
  target_id: string;
  req_id: string;
  subcatagory: string;
  action: string;
  operator: string;
  before_data: Record<string, unknown> | null;
  after_data: Record<string, unknown> | null;
  description: string;
  ip_address: string | null;
  created_at: string;
}

export const listBswProjects = async (): Promise<{ code: number; data: BswProject[] }> => {
  const res = await apiClient.get('/bsw-req/projects/');
  return res.data;
};

export const compareRequirements = async (params: {
  srcProject: string;
  srcSubcatagory: string;
  desProject: string;
  desSubcatagory: string;
}): Promise<SyncCompareResponse> => {
  const res = await apiClient.get('/bsw-req/sync/compare/', { params });
  return res.data;
};

export const executeSync = async (payload: SyncExecutePayload): Promise<{ code: number; message: string; data: unknown }> => {
  const res = await apiClient.post('/bsw-req/sync/execute/', payload);
  return res.data;
};

export const getMainlineProjectsWithReqs = async (params: {
  subcatagory: string;
  req_ids: string;
}): Promise<{ code: number; data: string[] }> => {
  const res = await apiClient.get('/bsw-req/mainline-projects-with-reqs/', { params });
  return res.data;
};

export const getOperationLogs = async (params?: {
  projectId?: number;
  target_type?: string;
  action?: string;
}): Promise<{ code: number; data: OperationLog[] }> => {
  const res = await apiClient.get('/bsw-req/logs/', { params });
  return res.data;
};
